import { createApp } from 'vue'
import App from './App.vue'
import 'swiper/swiper-bundle.css'
import './assets/css/mobile-swiper.css'


createApp(App).mount('#showcase-app')
